import axios from 'axios';

const WEBINAR_API_BASE = 'https://pagepilot.fabbuilder.com/api';

export const webinarApi = {
    getAvailableSlots: async (scheduleId: string, filter?: any) => {
        const params = {
            filter
        }
        const response = await axios.get(
            `${WEBINAR_API_BASE}/webinar-schedule/${scheduleId}`,
            { params }
        );
        return response.data;
    },
};
